<template>
    <div class="mag-cover">
        <sep name="XL" />
        <main-container class="title">
            <typo name="title-30-bold">{{ title }}</typo>
            <typo name="title-24-bold">{{ subtitle }}</typo>
        </main-container>
        <img :src="cover" />
    </div>
</template>

<script>

export default {
    props: ["cover", "title", "subtitle"],
};
</script>

<style lang="sass" scoped>
.mag-cover
    width: 100%
    height: 300px
    position: relative
    img
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 300px
        object-fit: cover
        object-position: center
        z-index: 0
    &:after
        position: absolute
        content: ""
        left: 0
        right: 0
        top: 0
        bottom: 0
        background: rgba(0,0,0,0.3)
        z-index: 1

    .title
        position: relative
        z-index: 2
        display: flex
        flex-direction: column
        color: white

@media print
    .mag-cover
        padding: 5.5mm 0
        height: 20mm

        .title
            color: $color-text

        img,
        &:after
            display: none
</style>
